export default {
  TOGGLE_EDIT: "SECTIONS/TOGGLE_EDIT",
  UPDATE_BODY: "SECTIONS/UPDATE_BODY",
};
